__turbopack_context__.v({
  "disclaimer": "home-module-scss-module__n1jdta__disclaimer",
  "hero": "home-module-scss-module__n1jdta__hero",
  "text": "home-module-scss-module__n1jdta__text",
});
